export default __webpack_public_path__ + "static/media/Barcode.995144f4.jpeg";